import React, { ReactNode } from "react";
import { Box, Center, ThemeIcon, Text } from "@mantine/core";
import { IconCircleCheckFilled, IconAlertTriangleFilled, IconCircleXFilled, IconSettingsFilled } from "@tabler/icons-react";
import { ConvertJST } from "../utils/DateUtils";

/**
 * 現在のステータスのコンテンツを生成
 * @param currentStatus 
 * @param instanceName 
 */
export const RenderCurrentStatusContents = (currentStatus: string, instanceName: string) => {
    let statusIcon: ReactNode;
    let statusIconColor: string;
    let statusMessage: ReactNode;
    const instanceText: ReactNode = (<Text fw={700} display={"inline"}>{instanceName}</Text>);
  
    switch (currentStatus) {
      case "critical":
        statusIcon = (<IconCircleXFilled style={{ width: '100%', height: '100%' }} />);
        statusIconColor = "red";
        statusMessage = (<Text>インスタンス「{instanceText}」で大幅な応答遅延が発生しています</Text>);
        break;
      case "warning":
        statusIcon = (<IconAlertTriangleFilled style={{ width: '100%', height: '100%' }} />);
        statusIconColor = "orange";
        statusMessage = (<Text>インスタンス「{instanceText}」で応答遅延が発生しています</Text>);
        break;
      case "maintenance":
        statusIcon = (<IconSettingsFilled style={{ width: '100%', height: '100%' }} />);
        statusIconColor = "#4169E1";
        statusMessage = (<Text>コラボフロークラウドはメンテナンス中です</Text>);
        break;
      default:
        statusIcon = (<IconCircleCheckFilled style={{ width: '100%', height: '100%' }} />);
        statusIconColor = "#21AF63";
        statusMessage = (<Text>インスタンス「{instanceText}」は正常に稼働しています</Text>);
        break
    }
  
    return (
      <Box>
        <Center>
          <ThemeIcon style={{ color: statusIconColor, backgroundColor: "#f3f3f3", width:"80px", height:"80px"}}>
            {statusIcon}
          </ThemeIcon>
        </Center>
        <Center>
          <Text mr={10} align="center">
            {statusMessage}
            {ConvertJST(new Date(), "YYYY/MM/DD HH:mm")}
          </Text>
        </Center>
      </Box>
    )
  }
  